import Radium from 'radium'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { selectLanguageStrings } from 'widget/dining/selectors/languageSelectors'
import { changeFormField } from '../actions/forms'
import { toggleModalDisplay } from '../actions/navigation'
import styles from '../assets/styles/checkout'
import { StripePaymentElementFields } from '@sevenrooms/payments'

class CheckoutPaymentStripe extends Component {
  constructor(props) {
    super(props)
    this.handleFirstNameChange = this.props.changeFormField.bind(this, 'cardFirstName')
    this.handleLastNameChange = this.props.changeFormField.bind(this, 'cardLastName')
  }

  render() {
    const {
      fontsColorPrimary,
      fontsColorCheckoutActive,
      colorPrimary,
      colorCheckoutCellBackground,
      colorLines,
      colorTextPlaceholder,
      topElementId,
      fontFamily,
      textPayment,
      textCardRequired,
      selectedLanguage,
      stripeIntentClientSecret,
      baseUrl,
      mediaUrl,
      amount,
    } = this.props

    return (
      <div id={topElementId} style={styles.sectionWrapper}>
        <div style={styles.labelWrapper}>
          <span style={[styles.sectionLabel, { color: fontsColorPrimary }]}>{amount ? textPayment : textCardRequired}</span>
        </div>
        <div style={styles.infoForm}>
          <div
            style={[
              styles.stripePaymentElement,
              {
                backgroundColor: colorCheckoutCellBackground,
              },
            ]}
          >
            <StripePaymentElementFields
              stripe={this.props.stripe || null}
              clientSecret={stripeIntentClientSecret}
              locale={selectedLanguage}
              fonts={`${baseUrl}${mediaUrl}css/fonts.css`}
              appearance={{
                variables: {
                  fontFamily,
                  fontSizeBase: styles.stripeIframe.fontSizeBase,
                  fontSizeSm: styles.stripeIframe.fontSizeBase,
                  fontSizeXs: styles.stripeIframe.fontSize,
                  colorPrimary,
                  colorTextPlaceholder,
                  colorTextSecondary: fontsColorCheckoutActive,
                  colorText: fontsColorPrimary,
                  tabIconSelectedColor: fontsColorPrimary,
                },
                rules: {
                  '.Tab, .Input, .Block, .CheckboxInput, .CodeInput': {
                    backgroundColor: 'transparent',
                    boxShadow: `0 0 1px 1px ${colorLines}`,
                    border: `1px solid ${colorLines}`,
                  },
                  '.Tab--selected': {
                    border: `1px solid ${fontsColorPrimary}`,
                    boxShadow: `0 0 1px 1px ${colorLines}`,
                  },
                  '.TabLabel': {
                    fontSize: styles.stripeIframe.fontSizeBase,
                    fontWeight: 'normal',
                    color: fontsColorPrimary,
                  },
                },
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { formFields, widgetSettings } = state
  const languageStrings = selectLanguageStrings(state)
  return {
    cardFirstName: formFields.get('cardFirstName'),
    cardLastName: formFields.get('cardLastName'),
    fontFamily: widgetSettings.font,
    fontsColorPrimary: widgetSettings.fontsColorPrimary,
    fontsColorCheckoutActive: widgetSettings.fontsColorCheckoutActive,
    colorTextPlaceholder: widgetSettings.fontsColorSecondary,
    colorPrimary: widgetSettings.colorPrimary,
    colorCheckoutCellBackground: widgetSettings.colorCheckoutCellBackground,
    colorLines: widgetSettings.colorLines,
    baseUrl: widgetSettings.baseUrl,
    mediaUrl: widgetSettings.mediaUrl,
    // text
    textPayment: languageStrings.textPayment,
    textCardRequired: languageStrings.textCardRequired,
  }
}

const mapDispatchToProps = dispatch => ({
  changeFormField: (field, changeTo) => {
    dispatch(changeFormField(field, changeTo))
  },
  toggleModalDisplay: modal => {
    dispatch(toggleModalDisplay(modal))
  },
})

CheckoutPaymentStripe = connect(mapStateToProps, mapDispatchToProps)(Radium(CheckoutPaymentStripe))

export default CheckoutPaymentStripe
